module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("In memory of Marilyn Young (1937–2017), whose brilliant historical scholarship challenges us to confront America’s addiction to war.")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("And to Spelman College activists, past and present, in their courageous struggle for a more just and democratic world.")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c5fffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0